import { RequiredTableCols } from "@ui-components/AgGridTable/constants/tableCols";

export const TranslateRequiredTableColumns = {
    [RequiredTableCols.DRAG]: "app.fields.drag",
    [RequiredTableCols.ROW_NUMBER]: "app.fields.rowNumber",
    [RequiredTableCols.ACTIONS]: "app.fields.actions",
};
